import {Analytics} from '../helpers/analytics';
import {ElementHelpers} from '../helpers/element-helpers';
import {Templates} from '../helpers/templates';
import {LazyLoadSingle} from './lazyload-single';
import {LazyloadVacancycard} from './lazyload-vacancycard';

export class LazyloadBoards {

	constructor(elem) {
		this.elem = elem;

		this.search = this.elem.dataset.lazyloadBoard === 'search';
		this.searchTerm = null;

		this.boards = this.elem.querySelectorAll('[data-lazy-board]');

		this.templates = {
			templateEventsCard: Templates.getTemplateFromPage('templateEventsCard'),
			templateBlogCard: Templates.getTemplateFromPage('templateBlogCard'),
			templateSearchCard: Templates.getTemplateFromPage('templateSearchCard'),
			templateFaq: Templates.getTemplateFromPage('templateFaq'),
			templateSearchEvent: Templates.getTemplateFromPage('templateSearchEvent'),
			templateSearchContact: Templates.getTemplateFromPage('templateSearchContact'),
			loadMore: Templates.getTemplateFromPage('templateLoadMore'),
			loadMorePast: Templates.getTemplateFromPage('templateLoadMore-Past'),
			noResults: Templates.getTemplateFromPage('templateNoResults')
		};

		this.form = document.querySelector('form');
		this.input = this.form ? this.form.querySelectorAll('input') : '';
		this.buttons = this.form ? this.form.querySelectorAll('.blog-filter__buttons button') : '';
		this.select = this.form ? this.form.querySelectorAll('select') : '';

		this.checkboxes = this.form ? this.form.querySelectorAll('input[type="checkbox"]') : '';
		this.textInputs = this.form ? this.form.querySelectorAll('input[type="search"]') : '';

		this.urlParams;

		// Button array for analytics
		this.selectedButtons = [];

		this.init();
	}

	init() {
		if (window.location.search) {
			this.updateInputs();
		}
		if ((!this.search) || window.location.search) this.loadBoards();
		this.addEventHandlers();
		this.toggleFilterClass();
	}

	loadBoards() {
		for (let i = 0; i < this.boards.length; i++) {
			if (this.boards[i].dataset.lazyBoard === 'searchCard') {
				new LazyloadVacancycard(this.boards[i], this.getQueryParams(), this.searchTerm);
			} else {
				new LazyLoadSingle(this.boards[i], this.getQueryParams(), this.templates, this.searchTerm, this.urlParams);
			}
		}
	}

	getQueryParams() {
		let inputs = this.input;
		let selects = this.select;
		let buttons = this.buttons;
		let divider = '&';
		let string = '';

		if (inputs) {
			string = this.getInputString(inputs, string, divider);
		}

		if (buttons) {
			string = this.getButtonString(buttons, string, divider);
		}

		if (selects) {
			string = this.getSelectsString(selects, string, divider);
		}

		return string;
	}

	getInputString(inputs, string, divider) {
		for (let i = 0; i < inputs.length; i++) {
			if (inputs[i].type === 'checkbox' && inputs[i].checked) {
				string += divider + inputs[i].name + '=' + encodeURIComponent(inputs[i].value);
			} else if (inputs[i].type === 'search' && inputs[i].value) {
				string += divider + inputs[i].name + '=' + encodeURIComponent(inputs[i].value);
			} else if (inputs[i].type === 'text' && inputs[i].value) {
				string += divider + inputs[i].name + '=' + encodeURIComponent(inputs[i].value);
			}
			inputs[i].blur();
			if (this.search) this.searchTerm = inputs[i].value;
		}
		return string;
	}

	getButtonString(buttons, string, divider) {
		for (let i = 0; i < buttons.length; i++) {

			if (buttons[i].classList.contains('active')) {
				string += divider + 'vakgebied' + '=' + encodeURIComponent(buttons[i].dataset.key);
			}
		}
		return string;
	}

	getSelectsString(selects, string, divider) {
		for (let i = 0; i < selects.length; i++) {
			if (!selects[i].disabled) {
				string += divider + selects[i].name + '=' + encodeURIComponent(selects[i].options[selects[i].selectedIndex].value);
			}
		}
		return string;
	}

	updateInputs() {
		let categories = {};
		let location = window.location.search.split('?')[1];
		let strs = location.split('&');

		if (strs) {
			for (let i = 0; i < strs.length; i++) {
				let str = strs[i].split('=');
				if (str[1]) {
					if (categories[str[0]]) {
						categories[str[0]] = categories[str[0]].concat([decodeURIComponent(str[1])]);
					} else {
						categories[str[0]] = [decodeURIComponent(str[1])];
					}
				}
			}
		}

		this.setUrlParams(categories);
		this.updateCheckboxes(categories, this.checkboxes);
		this.updateTextFields(categories, this.textInputs);
	}

	// Might need it when we do the filter story
	// updateSelects(categories, selects) {
	// 	if (selects) {
	// 		for (let i = 0; i < selects.length; i = i + 1) {
	// 			let name = selects[i].name,
	// 				options = selects[i].options,
	// 				category = categories[name];
	//
	// 			for (let j = 0; j < options.length; j = j + 1) {
	// 				if (category && category.indexOf(options[j].value) > -1) {
	// 					options[j].selected = true;
	// 				}
	// 			}
	// 		}
	// 	}
	// }

	updateTextFields(categories, inputs) {
		if (inputs) {
			for (let i = 0; i < inputs.length; i = i + 1) {
				let name = inputs[i].name,
					category = categories[name];
				if (category) inputs[i].value = category[0];
			}
		}
	}

	updateCheckboxes(categories, checkboxes) {
		if (checkboxes) {
			for (let i = 0; i < checkboxes.length; i = i + 1) {
				let name = checkboxes[i].name,
					category = categories[name];
				if (category) {
					let index = category.indexOf(checkboxes[i].value);
					if (index > -1) {
						let cat = (typeof category === 'object') ? category[index] : category;
						checkboxes[i].checked = cat === checkboxes[i].value;
					} else {
						checkboxes[i].checked = false;
					}
				} else {
					checkboxes[i].checked = false;
				}
			}
		}
	}

	/**
	 * Set UrlParameters object to pass it to the Ajax call
	 * @param urlParams
	 */
	setUrlParams(urlParams) {
		this.urlParams = urlParams;
	}

	addEventHandlers() {
		ElementHelpers.addEventListeners(this.checkboxes, 'change', () => {
			this.loadBoards();
			this.clearUrlParams();
		});

		ElementHelpers.addEventListeners(this.textInputs, 'search', () => {
			this.loadBoards();
			this.clearUrlParams();
		});

		if (this.form) {
			this.form.addEventListener('submit', (event) => {
				event.preventDefault();
				event.stopPropagation();
				this.loadBoards();
				this.clearUrlParams();
				if (this.search) {
					const data = {
						category: this.form.dataset.analyticsLazyCategory,
						action: this.form.dataset.analyticsLazyAction,
						label: this.form.dataset.analyticsLazyLabel,
						keyword: this.searchTerm
					};
					Analytics.measure(data, '', 'click', '_trackEvent', false);
				}
			});
		}
	}

	static getSelector() {
		return '[data-lazyload-board]';
	}

	createVakgebiedenArray(text) {
		// Got this from https://stackoverflow.com/a/9604509
		var j;  //  Basic variable to be used if index of item exist
		//  The following is simply an opening to an inline if statement.
		//  It's wrapped in () because we want `i` to equal the index of the item, if found, not what's to follow the `?`.
		//  So this says "If i = an index value less than 0".
		(j = this.selectedButtons.indexOf(text)) < 0 ?
			//  If it was not found, the index will be -1, thus push new item onto array
			this.selectedButtons.push(text) :
			//  If found, i will be the index of the item found, so we can now use it to simply splice that item from the array.
			this.selectedButtons.splice(j, 1);

		return this.selectedButtons.toString();
	}

	toggleFilterClass() {
		const self = this;
		let timerid;
		for (let i = 0; i < this.buttons.length; i++) {
			this.buttons[i].addEventListener('click', function (event) {
				this.classList.toggle('active');
				// Handle analytics with Timeout (because Frank Verburg asked);
				if (timerid) {
					clearTimeout(timerid);
				}
				const label = self.createVakgebiedenArray(event.target.innerHTML);
				const filterName = this.getAttribute('data-filter-name') || 'vakgebied';
				timerid = setTimeout(() => {
					const data = {
						action: 'click - interact',
						category: this.dataset.analyticsLazyCategory,
						label: `${filterName} - ${label}`
					};
					Analytics.measure(data);
				}, 1000);
			})
		}
	}

	clearUrlParams() {
		this.urlParams = undefined;
	}

}

